// Generated by Melange

import * as Buhta_cabinet__Api from "../../../core/Api.js";
import * as Buhta_cabinet__Crm from "../../../models/Crm.js";
import * as Buhta_cabinet__HelpChatInfoPanel from "../../../components/organisms/Admin/Chat/HelpChatInfoPanel.js";
import * as Buhta_cabinet__HelpChatPanel from "../../../components/organisms/Admin/Chat/HelpChatPanel.js";
import * as Buhta_cabinet__Request from "../../../core/Request.js";
import * as Buhta_components__LoadingDiv from "../../../../../../packages/components/src/atoms/LoadingDiv.js";
import * as Curry from "melange.js/curry.js";
import * as JsxRuntime from "react/jsx-runtime";

function make(id) {
  return function (onClose) {
    const ticket = Buhta_cabinet__Request.useFetch(Curry._2(Buhta_cabinet__Api.Endpoints.Crm.tickets, id, undefined), Buhta_cabinet__Crm.Ticket.decodeDetailed, undefined);
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(Buhta_cabinet__HelpChatPanel.make, {
                        ticket: ticket,
                        onClose: onClose,
                        className: "border-r border-gray-main"
                      }),
                  typeof ticket === "string" ? JsxRuntime.jsx(Buhta_components__LoadingDiv.make, {}) : (
                      ticket.NAME === "Data" ? JsxRuntime.jsx(Buhta_cabinet__HelpChatInfoPanel.make, {
                              orgId: ticket.VAL.org.id
                            }) : "Error: " + ticket.VAL.message
                    )
                ],
                className: "grid grid-cols-6-3 h-full"
              });
  };
}

function HelpChatLayout(Props) {
  return make(Props.id)(Props.onClose);
}

const make$1 = HelpChatLayout;

export {
  make$1 as make,
}
/* Buhta_cabinet__Crm Not a pure module */
